export const ERROR_FORBIDDEN = 403;
export const ERROR_CONFLICT = 409;
export const ERROR_TOO_MANY_REQUESTS = 429;
